const bannerStyles =
  "col-span-2 mb-8  px-8 pt-4 pb-2 text-left  text-3xl  text-green-900 border-b-2  font-semibold  border-green-900 border-solid  xl:py-4  xl:text-4xl ";

export default bannerStyles;
